<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{ search, api, ...dialog, ...table, ...tree, title: '字典数据' }"
    :initialForm="initialForm"
    @action="handleAction"
  >
  </zh-table-page>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const blurText = async (rule, value, callback) => {
      const boolean = new RegExp("^[1-9][0-9]*$").test(value); // console.log(boolean)
      if (!boolean) {
        callback(new Error("只为能正整数"));
      }
    };
    const state = reactive({
      search: [
        {
          label: "字典标签",
          placeholder: "字典标签",
          value: "dictLabel",
        },
      ],
      api: {
        list: "postDictDataPage",
        delete: "deleteDictDataDelete",
        deleteAll: "",
        add: "postDictDataSave",
        edit: "postDictDataUpdate",
        detail: null,
        exportAll: "",
        tree: "getDictTypeGetDictTpyeTree",
        path: "", //详情页面路由
      },
      table: {
        columns: [
          { label: "字典标签", prop: "dictLabel", width: "150" },
          { label: "字典键值", prop: "dictValue", width: "120" },
          { label: "字典类型名称", prop: "dictName", width: "120" },
          { label: "字典类型", prop: "dictType" },
          { label: "字典排序", prop: "dictSort", width: "120" },
          // {
          //   label: "状态",
          //   prop: "status",
          //   scopeComponent:"zh-switch"
          // },
          { label: "备注", prop: "remark" },
          { label: "创建时间", prop: "createTime", width: "180" },
        ],
      },
      dialog: {
        dialogForm: [
          {
            component: "zh-tree-select",
            label: "字典类型",
            placeholder: "请选择字典类型",
            value: "dictTypeId",
            disabled: true,
            url: "getDictTypeGetDictTpyeTree",
            field: {
              id: "value",
              dictName: "label",
            },
          },
          {
            label: "数据标签",
            placeholder: "请输入数据标签",
            value: "dictLabel",
          },
          {
            label: "数据键值",
            placeholder: "请输入数据键值",
            value: "dictValue",
            type: "number",
          },
          // {
          //   label: "样式属性",
          //   placeholder: "请输入样式属性",
          //   value: "cssClass",
          // },
          {
            component: "el-input-number",
            label: "显示排序",
            placeholder: "请输入显示排序",
            value: "dictSort",
            defaultValue: 1,
            min: 1,
          },
          {
            component: "zh-select",
            label: "回显样式",
            placeholder: "请选择回显样式",
            value: "listClass",
            options: [
              {
                value: "default",
                label: "默认",
              },
              {
                value: "primary",
                label: "主要",
              },
              {
                value: "success",
                label: "成功",
              },
              {
                value: "info",
                label: "信息",
              },
              {
                value: "warning",
                label: "警告",
              },
              {
                value: "danger",
                label: "危险",
              },
            ],
          },
          {
            label: "备注信息",
            placeholder: "请输入内容",
            value: "remark",
            type: "textarea",
          },
        ],
        dialogRules: {
          dictLabel: [
            { required: true, message: "数据标签不能为空", trigger: "blur" },
          ],
          dictValue: [
            { required: true, message: "数据键值不能为空", trigger: "blur" },
          ],
          dictSort: [
            { required: true, message: "数据顺序不能为空", trigger: "blur" },
            { validator: blurText, trigger: "change" },
          ],
          status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        },
      },
      tree: {
        treeField: {
          dictName: "label",
        },
      },
    });
    onMounted(() => {});
    const initialForm = (data) => {
      if (data) {
        return {
          dictTypeId: data.id,
          dictType: data.dictType,
        };
      } else {
        proxy.$message.warning("请选择字典类型");
        return false;
      }
    };
    const handleAction = (item, type) => {
      if (type === "scope") {
        proxy
          .$confirm("是否修改字典数据状态?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            proxy.$api
              .postDictDataUpdate({
                ...item,
                status: item.status.value == 1 ? 0 : 1,
              })
              .then((res) => {
                tableRef.value.handleSearch();
                proxy.$message.success("操作成功");
              });
          })
          .catch(() => {
            tableRef.value.handleSearch();
          });
      }
    };
    return {
      ...toRefs(state),
      tableRef,
      initialForm,
      handleAction,
    };
  },
});
</script>
